import React, { ReactNode } from "react"
import styled, { css } from "styled-components"
import { Box, Row } from "@jobintrans/base-ui.components.atoms._atoms"
import Icon from "@jobintrans/base-ui.components.atoms.icon"

const SelectRow = ({
  checked,
  label,
  value,
  onClick,
  disabled = false,
  $showBorder = true,
  $withBackground = false,
}: {
  checked: boolean
  label: ReactNode
  value?: ReactNode
  onClick: () => void
  disabled?: boolean
  $showBorder?: boolean
  $withBackground?: boolean
}) => {
  return (
    <Wrapper $disabled={disabled} $showBorder={$showBorder} $withBackground={$withBackground}>
      <CheckWrapper
        $active={!disabled && checked}
        $disabled={disabled}
        onClick={disabled ? () => {} : onClick}
      >
        <Icon icon="check" $size="10px" $opacity={checked ? 1 : 0} $color="white" />
      </CheckWrapper>
      <Content
        $flex={1}
        $alignItems="center"
        $justifyContent="space-between"
        $marginLeft="XS"
        $opacity={disabled ? 0.6 : 1}
      >
        <Box $width="100%" $flex={1}>
          {label}
        </Box>
        {value && <Box>{value}</Box>}
      </Content>
    </Wrapper>
  )
}

export default SelectRow

const CheckWrapper = styled(Box)<{
  $active: boolean
  $disabled: boolean
}>`
  width: 25px;
  height: 25px;
  border: 1px solid ${({ theme }) => theme.color.border};
  background: none;
  border-radius: 50%;
  transition: all 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  ${({ $active }) =>
    $active &&
    css`
      border: 1px solid ${({ theme }) => theme.color.primary};
      background: ${({ theme }) => theme.color.primary};
      cursor: pointer;
    `}

  ${({ $disabled }) =>
    $disabled &&
    css`
      cursor: not-allowed;
    `}
`

const Content = styled(Row)`
  flex-wrap: wrap;
  grid-gap: ${({ theme }) => theme.space.S};

  @media (max-width: 700px) {
    flex-direction: column;
    align-items: flex-end;
  }
`

const Wrapper = styled(Box)<{
  $disabled: boolean
  $showBorder: boolean
  $withBackground: boolean
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.space.XS} ${({ theme }) => theme.space.S};
  border-radius: ${({ theme }) => theme.variable.borderRadius};

  ${({ $showBorder }) =>
    $showBorder &&
    css`
      border: 1px solid ${({ theme }) => theme.color.border};
    `};

  ${({ $withBackground }) =>
    $withBackground &&
    css`
      background: white;
    `};

  ${({ $disabled }) =>
    $disabled &&
    css`
      cursor: not-allowed;

      * {
        cursor: not-allowed;
      }
    `};
`
